module.exports = __webpack_public_path__ + "static/media/eject.44c1148d.svg";